import { UITagButton } from "common/components";
import { useDispatch } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { updateTopicsFilter } from "domains/monitor/filter/actions";
import type { Topic } from "entities/topics/types";

type FilterTagsProps = { items: Topic[]; selectedItems: string[] };

export const FilterTags = ({ items, selectedItems }: FilterTagsProps) => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  const onClick = (id: string) => () => {
    const removeFilter = selectedItems.includes(id);

    const newItems = removeFilter ? selectedItems.filter((item) => item !== id) : [id, ...selectedItems];
    dispatch(updateTopicsFilter(newItems));
  };

  const clear = () => dispatch(updateTopicsFilter([]));

  return (
    <>
      <UITagButton isActive={selectedItems.length === 0} onClick={clear}>
        {translate("app.discover.topic.tabs.knowledge.filter.options.all")}
      </UITagButton>
      {items.map((item) => (
        <UITagButton key={item.id} isActive={selectedItems.includes(item.id)} onClick={onClick(item.id)}>
          {item.name}
        </UITagButton>
      ))}
    </>
  );
};
